import instanceAxios from '../config/api'
import { Delai, DelaiResponse } from '../types/delaisTypes'
const API_URL = '/delais'

export const deleteDelaiApi = async (DelaiId: string) => {
  const response = await instanceAxios.delete<Delai[]>(`${API_URL}/` + DelaiId)
  return response.data
}

export const addDelaiApi = async (newDelai: Delai): Promise<Delai> => {
  const response = await instanceAxios.post<Delai>(`${API_URL}`, newDelai)
  return response.data
}

export const getDelaibyIdApi = async (DelaiId: string) => {
  const response = await instanceAxios.get<Delai>(`${API_URL}/` + DelaiId)
  return response.data
}

export const updateDelaiApi = async (
  updatedDelai: Delai,
  _id: string
): Promise<Delai> => {
  const response = await instanceAxios.put<Delai>(
    `${API_URL}/${_id}`,
    updatedDelai
  )
  return response.data
}

export const getDelaiByActionIdApi = async (ActionId: string) => {
  const response = await instanceAxios.get<DelaiResponse>(
    `actions/getDelais/${ActionId}`
  )
  return response
}
